(function () {
    'use strict';

    angular
        .module('app.accountSettings')
        .constant('accountSettingsResolver', {
            data: getSettings
        });

    var extend = angular.extend;

    getSettings.$inject = ['$transition$', 'Member', 'user'];
    function getSettings($transition$, Member, user) {
        return Member.getSettings({ id: user.id }).$promise.then(success);
        function success(data) {
            return extend(data, { isNewMember: !!$transition$.params().new });
        }
    }
})();